
import {Component, Prop, Vue} from "vue-property-decorator";
import {Nutritions} from "@/models/Recipes/Nutritions";
import {NutrientType} from "@/models/Ingredient/NutrientType";
import {NUTRIENT_UNIT_MAP, round} from "@/utils/Helpers";
import LockIcon from "@/components/icons/LockIcon.vue";
import VTrialMasker from "@/components/vTrialMasker.vue";

@Component({
  components: {VTrialMasker, LockIcon}
})
export default class vSupplementLabelUS extends Vue {
  @Prop() nutrition!: Nutritions;
  @Prop({ default: true }) showRoundedDv!: boolean;
  @Prop() servingsPerContainer: number;

  NutrientType = NutrientType;

  get servingSize() {
    const s = this.nutrition.displayServingQuantityAndMeasure;
    return s ? `${round(s.item1, 2)} ${s.item2}` : "—";
  }

  getRounded(nutrient: NutrientType): number {
    return round(this.nutrition.getRoundedValue(nutrient), 2);
  }

  getDV(nutrient: NutrientType): number | null {
    const dv = this.nutrition.getRoundedDailyValue(nutrient);
    return dv === null ? null : round(dv, 0);
  }

  getUnit(nutrient: NutrientType): string {
    return NUTRIENT_UNIT_MAP.get(nutrient);
  }

  getDVLabel(nutrient: NutrientType): string {
    const dv = this.getDV(nutrient);
    return dv === null ? "†" : `${dv}%`;
  }

  getNutrientLabel(nutrient: NutrientType): string {
    return NutrientType[nutrient].replace(/([A-Z])/g, " $1").trim();
  }

  get hasNoDV(): boolean {
    return this.vitaminsAndMinerals.some((n) => this.getDV(n) === null);
  }

  get vitaminsAndMinerals(): NutrientType[] {
    const nutrients: NutrientType[] = [
      NutrientType.VitaminA,
      NutrientType.VitaminC,
      NutrientType.VitaminD,
      NutrientType.VitaminE,
      NutrientType.VitaminK,
      NutrientType.Thiamine,
      NutrientType.Riboflavin,
      NutrientType.Niacin,
      NutrientType.VitaminB6,
      NutrientType.Folate,
      NutrientType.VitaminB12,
      NutrientType.Biotin,
      NutrientType.PantothenicAcid,
      NutrientType.Calcium,
      NutrientType.Iron,
      NutrientType.Phosphorus,
      NutrientType.Iodine,
      NutrientType.Magnesium,
      NutrientType.Zinc,
      NutrientType.Selenium,
      NutrientType.Copper,
      NutrientType.Manganese,
      NutrientType.Chromium,
      NutrientType.Molybdenum,
      NutrientType.Chloride,
      NutrientType.Choline,
      NutrientType.Potassium,
      NutrientType.Caffeine,
      NutrientType.Taurine,
    ];

    return nutrients.filter((nutrient) => {
      const value = this.nutrition.getRoundedValue(nutrient);
      return value !== 0 && value !== null && value !== undefined;
    });
  }
}
